module.exports = __webpack_public_path__ + "media/leipzig/employers-map-leipzig-0c5d23f6.webp";